import { render, staticRenderFns } from "./Advantages.vue?vue&type=template&id=ba3d0c1a&scoped=true&"
import script from "./Advantages.vue?vue&type=script&lang=js&"
export * from "./Advantages.vue?vue&type=script&lang=js&"
import style0 from "./Advantages.vue?vue&type=style&index=0&id=ba3d0c1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3d0c1a",
  null
  
)

export default component.exports